import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'

// Import statiques
import Accueil from '@/views/Accueil.vue'
import Login from '@/views/Login.vue'

// Import dynamiques
const Agent = () => import('@/views/TitulairePermis/Agent.vue')
const RepresentantLogiciel = () =>
  import('@/views/TitulairePermis/RepresentantLogiciel.vue')
const CapaciteFinanciere = () => import('@/views/CapaciteFinanciere.vue')
const CommandeTP = () => import('@/views/TitulairePermis/CommandeTP.vue')
const CommandeIP = () => import('@/views/CommandeIP/CommandeIP.vue')
const CommandeIPDetail = () => import('@/views/CommandeIP/CommandeIPDetail.vue')
const CommandeTPDetail = () =>
  import('@/views/TitulairePermis/CommandeTPDetail.vue')
const DemandeIP = () => import('@/views/DemandeIP/DemandeIP.vue')
const DemandeBrouillon = () => import('@/views/DemandeIP/DemandeBrouillon.vue')
const DemandeIPConfirmation = () =>
  import('@/views/DemandeIP/DemandeIPConfirmation.vue')
const Factures = () => import('@/views/TitulairePermis/Factures.vue')
const Favoris = () => import('@/views/TitulairePermis/Favoris.vue')
const FavorisEdit = () => import('@/views/TitulairePermis/FavorisEdit.vue')
const Fournisseur = () => import('@/views/Fournisseur.vue')
const Historique = () => import('@/views/Historique.vue')
const HistoriqueDemande = () =>
  import('@/views/DemandeIP/HistoriqueDemande.vue')
const ProfilEdit = () => import('@/views/ProfilEdit.vue')
const ModalitesRenseignement = () =>
  import('@/views/DemandeIP/ModalitesRenseignement.vue')
const MdpOublie = () => import('@/views/MdpOublie.vue')
const PolitiqueParticulier = () =>
  import('@/views/DemandeIP/PolitiqueParticulier.vue')
const PolitiqueTitulairePermis = () =>
  import('@/views/DemandeIP/PolitiqueTitulairePermis.vue')
const Rapports = () => import('@/views/Rapports.vue')
const ReinitialiserMdp = () => import('@/views/ReinitialiserMdp.vue')
const RechercheDemande = () => import('@/views/DemandeIP/RechercheDemande.vue')
const RechercheProduit = () => import('@/views/RechercheProduit.vue')
const RechercheTP = () => import('@/views/RechercheTP.vue')
//const RechercheIP = () => import('@/views/TitulairePermis/RechercheIP.vue')
const RetourMarchandiseManager = () =>
  import('@/views/RetourMarchandiseManager.vue')
const GererCarte = () => import('@/views/TitulairePermis/GererCarte.vue')
const AjouterCarte = () => import('@/views/TitulairePermis/AjouterCarte.vue')
const ModifierCarte = () => import('@/views/TitulairePermis/ModifierCarte.vue')
const TokenExpire = () => import('@/views/TokenExpire.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/accueil',
      name: 'accueil',
      component: Accueil
    },

    {
      path: '/agent',
      name: 'agent',
      component: Agent
    },
    {
      path: '/representantLogiciel',
      name: 'representantLogiciel',
      component: RepresentantLogiciel
    },
    {
      path: '/capaciteFinanciere',
      name: 'capaciteFinanciere',
      component: CapaciteFinanciere
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { anonymous: true }
    },
    {
      path: '/commandeTP',
      name: 'commandeTP',
      component: CommandeTP
    },
    {
      path: '/commandeIP',
      name: 'commandeIP',
      component: CommandeIP
    },
    {
      path: '/commandeIPDetail/:idCommande',
      name: 'commandeIPDetail',
      component: CommandeIPDetail
    },
    {
      path: '/commandeTPDetail/:idCommande',
      name: 'commandeTPDetail',
      component: CommandeTPDetail
    },
    {
      path: '/demandeIP',
      name: 'demandeIP',
      component: DemandeIP
    },
    {
      path: '/demandeBrouillon',
      name: 'demandeBrouillon',
      component: DemandeBrouillon
    },
    {
      path: '/demandeIPConfirmation/:noDemande',
      name: 'demandeIPConfirmation',
      component: DemandeIPConfirmation
    },
    { path: '/factures', name: 'factures', component: Factures },
    { path: '/favoris', name: 'favoris', component: Favoris },
    {
      path: '/favorisEdit/:idListe',
      name: 'favorisEdit',
      component: FavorisEdit
    },
    { path: '/fournisseur', name: 'fournisseur', component: Fournisseur },
    {
      path: '/historique',
      name: 'historique',
      component: Historique
    },
    {
      path: '/historiqueDemande',
      name: 'historiqueDemande',
      component: HistoriqueDemande
    },
    {
      path: '/profilEdit',
      name: 'profilEdit',
      component: ProfilEdit
    },
    {
      path: '/modalitesRenseignement',
      name: 'modalitesRenseignement',
      component: ModalitesRenseignement,
      meta: { anonymous: true }
    },
    {
      path: '/politiqueParticulier',
      name: 'politiqueParticulier',
      component: PolitiqueParticulier,
      meta: { anonymous: true }
    },
    {
      path: '/politiqueTitulairePermis',
      name: 'politiqueTitulairePermis',
      component: PolitiqueTitulairePermis,
      meta: { anonymous: true }
    },
    {
      path: '/mdp',
      name: 'mdpOublie',
      component: MdpOublie,
      meta: { anonymous: true }
    },
    {
      path: '/mdp/reinitialiser/:token',
      name: 'mdpReinitialiser',
      component: ReinitialiserMdp,
      meta: { anonymous: true }
    },
    {
      path: '/tokenExpire',
      name: 'tokenExpire',
      component: TokenExpire,
      meta: { anonymous: true }
    },
    {
      path: '/rapports',
      name: 'rapports',
      component: Rapports
    },
    {
      path: '/rechercheDemande',
      name: 'rechercheDemande',
      component: RechercheDemande
    },
    {
      path: '/rechercheProduit',
      name: 'rechercheProduit',
      component: RechercheProduit
    },
    {
      path: '/rechercheTP',
      name: 'rechercheTP',
      component: RechercheTP
    },
    // {
    //  path: '/rechercheIP',
    //  name: 'rechercheIP',
    //  component: RechercheIP
    //},
    {
      path: '/retourMarchandise',
      name: 'retourMarchandise',
      component: RetourMarchandiseManager,
      meta: {
        hideGlobalProductSearch: true
      }
    },
    {
      path: '/gererCarte',
      name: 'gererCarte',
      component: GererCarte
    },
    {
      path: '/ajouterCarte',
      name: 'ajouterCarte',
      component: AjouterCarte
    },
    {
      path: '/modifierCarte',
      name: 'modifierCarte',
      component: ModifierCarte
    },
    { path: '/index.html', name: 'index', component: Accueil }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.getters.estAuthentifie && to.name === 'login') {
    console.log(
      `Usage authentifie qui tente d'acceder a la page de login, on redirige vers accueil`
    )
    next({ name: 'accueil' })
    return
  }

  // Anonymous page: continue
if (to.meta !== undefined && to.meta.anonymous) {
    console.info(`Acces anonyme, on continue vers ${to.fullPath}`)
    next()
    return
}

  // Check is user logged in. If not redirect to login
  if (store.getters.estAuthentifie) {
    console.info(`Usager connecte, on continue vers ${to.fullPath}`)
    next()
    return
  }

  // Redirect to login page
  console.info('User pas connecte, redirection vers /login')
  next('login')
})

export default router
